import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontWeight: 'bold',
        textTransform: 'uppercase',
        color: theme.palette.grey[400],
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
